/**
 * Product quantity functionality
 *
 * Added plus and minus buttons to the quantity field
 *
 * @author Ryan Hutchinson (rhutchinson@lyonscg.com)
 */
'use strict';
var linchpin = require('int_googletagmanager/linchpin/quantity');
var quantity = {
	data: {
		btn: null,
		btnType: 'data-type',
		typeA: 'minus',
		typeB: 'plus'
	},

	init: function (callback) {
		quantity.data.btn = $('.btn-number');
		quantity.btnClick(callback);
		var self = this;

		$('.item-quantity-details [type="number"]').on('keyup', function () {
			self.btnAccessibility($(this), $(this).val());
		});

		$('.input-group-qty').on('keyup change', function () {
			if (typeof callback === 'function') {
				callback.call();
			}
		});

		// allow only numbers and ctrl+A, limit value to max 100
		var isSelect = false;
		$('.input-group-qty').on('select', function () {
			isSelect = true;
		});
		$('.input-group-qty').on('focusout', function () {
			isSelect = false;
			if ($(this).val() === '0') {
				$(this).val(1);
			}
		});
		$('.input-group-qty').on('keypress change', function (e) {
			var code = e.which ? e.which : e.keyCode;
			var valid = false;
			if (code >= 48 && code <= 57) {
				var intendedValue = isSelect ? String.fromCharCode(code) : $(this).val().toString() + String.fromCharCode(code);
			} else {
				var intendedValue = $(this).val().toString();
			}
			isSelect = false;

			if ((code === 65 && e.ctrlKey === true) ||
				(code >= 48 && code <= 57 && !e.shiftKey) &&
				intendedValue <= 299) {
				valid = true;
			}

			if (intendedValue > 299) {
				$(this).val(299);
			}

			if (!valid) {
				e.preventDefault();
			}

			if (!intendedValue) {
				$('#add-to-cart').prop('disabled', true);
			} else {
				$('#add-to-cart').prop('disabled', false);
			}

			// convert to number to remove extra zeros
			var numericValue = parseInt($(this).val());
			$(this).val(numericValue);
		});

		$('.update-qty').on('click', function () {
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.updateQuantityEvent();
			}
		});
	},

	btnClick: function (callback) {
		quantity.data.btn.off('click');
		quantity.data.btn.on('click', function () {
			var $inputGroup = $(this).closest('.input-group').first();
			var $inputElement = $inputGroup.find('.input-text');
			if ($(this).attr(quantity.data.btnType) === quantity.data.typeA) {
				quantity.btnActionSub($inputElement);
			} else if ($(this).attr(quantity.data.btnType) === quantity.data.typeB) {
				quantity.btnActionAdd($inputElement);
			}
			$('.update-qty').trigger('click');
			// FIXME:
			// if quantity module is included several times on a page (e.g. PDP + minicart, CLP quick view + minicart)
			// the callback set on first quantity.init(cb1) call is overwritten by next quantity module initialization quantity.init(cb2)
			// cb1 func will be never called in such case
			if (typeof callback === 'function') {
				callback.call();
			}

			// Update mini-cart "Update" button state
			var $minicartQtyControls = $(this).closest('.mini-cart-product-update');
			if ($minicartQtyControls.length > 0) {
				var $qtyInput = $minicartQtyControls.find('input.input-text');
				var $updateLink = $minicartQtyControls.find('.update-link button');
				if ($qtyInput.val() !== $qtyInput.attr('value')) {
					$updateLink.prop('disabled', false);
				} else {
					$updateLink.prop('disabled', true);
				}
			}
		});
	},

	btnAccessibility: function (el, newVal) {
		var onloadQty = parseFloat(el.data('onload-qty')),
			updateBtnContainer = el.closest('.item-quantity-details'),
			updateBtn;

		if (!updateBtnContainer) {
			return;
		} else {
			updateBtn = updateBtnContainer.find('.update-qty');
		}
		if (onloadQty && newVal !== onloadQty && !isNaN(parseFloat(newVal))) {
			updateBtn.prop('disabled', false);
		} else {
			updateBtn.prop('disabled', true);
		}
	},

	btnActionSub: function (inputElm) {
		var currentVal = parseFloat(inputElm.val());
		quantity.btnAccessibility(inputElm, currentVal - 1);
		if (currentVal > inputElm.attr('min')) {
			inputElm.val(currentVal - 1).change();
		}
	},

	btnActionAdd: function (inputElm) {
		var currentVal = parseFloat(inputElm.val());
		quantity.btnAccessibility(inputElm, currentVal + 1);
		if (currentVal < inputElm.attr('max')) {
			inputElm.val(currentVal + 1).change();
		}
	}
};

module.exports = quantity;
